import Axios from 'axios';
import {DatasetGetAnnotationsResponse} from '../../types/dataset/DatasetGetAnnotationsResponse';

type GetAnnotationsRequest = {
  applicationId: string;
};

export async function getAnnotations({applicationId}: GetAnnotationsRequest) {
  return Axios.request<DatasetGetAnnotationsResponse>({
    method: 'GET',
    url: `/studio/dataset/application/${applicationId}/get_image_categories`,
  });
}
